import { useEffect, useRef } from 'react';

// custom react hook for setting intervals
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// declarative way to set interval; will be especially useful when adjusting frequency or pausing
function useInterval(callback, delay, ...args) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, ...args]);
}

export default useInterval;
